import { SubscriptionStatusString } from '@/types';

export const IS_PATREP_KEY = 'is_patrep';

export const PAYMENT_STATUS_LIST: SubscriptionStatusString[] = [
  'payment_successful',
  'payment_failed',
  'order_processed',
  'waiting_for_pickup',
  'picked_up',
  'on_delivery',
  'delivered',
  'delivery_failed',
  'active',
];

export const DETAIL_SUBSCRIPTION_STATUS_LIST: SubscriptionStatusString[] = [
  'pending_address',
  'waiting_for_payment',
  'payment_order',
  'payment_expired',
  'order_cancelled',
];
